/* eslint-disable react/no-unused-state */
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";

// import Drift from "./Drift";
import FreshWorksWidget from "./FreshWorksWidget";
import { GlobalUtils } from "../../utils";
// import { DRIFT_PLAYBOOKS } from "../../constants/document";
import DriftLoader from "./DriftLoader";
import { getDriftAvatarImage } from "../../actions/CommonActions/commonService";
import { IMAGE_URLS } from "../../constants";

const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;
const { CHAT_PERSON_IMAGE } = IMAGE_URLS;

class DriftWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChatOpen: false,
      isChatLoading: false,
      showAvatar: this.props.showAvatar,
      isOptionsMenuOpen: false,
      avatarImage: null,
      isFirstLoad: true,
      conversationId: null,
      options: [
        {
          id: "chat",
          icon: "comments-alt",
          title: "Drop us a message",
          subtext: "Ping us anytime, we have a team ready to help you.",
          link: null,
        },
        {
          id: "help_articles",
          icon: "book-open",
          title: "Help articles",
          subtext: "Explore Revv on your own with documented help from us.",
          link: "https://www.revv.so/docs",
        },
        {
          id: "revv_learn",
          icon: "video",
          title: "Revv learn",
          subtext: "Binge watch short tutorials to get started in no time.",
          link: "https://www.revv.so/learn.html",
        },
      ],
    };
  }

  _handleItemClick = item => {
    if (item.id === "chat") {
      if (!window.FreshworksWidget) {
        this.setState({
          isChatOpen: true,
          isChatLoading: true,
          isOptionsMenuOpen: false,
          showAvatar: false,
          conversationId: null,
        });
      } else {
        this.setState({
          isOptionsMenuOpen: false,
          isChatOpen: true,
        });
        window.FreshworksWidget("open");
      }

      // if (!process.env.REACT_APP_DRIFT_APPID) {
      //   this._initListners(false);
      // }
    } else if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  // _handleOustideClick = e => {
  //   if (
  //     e &&
  //     e.target &&
  //     e.target.classList &&
  //     e.target.classList.value &&
  //     !e.target.classList.value.includes("help-fab") &&
  //     !e.target.classList.value.includes("drift-") &&
  //     !this.state.showAvatar &&
  //     !this.state.isChatOpen &&
  //     !this.state.isChatLoading &&
  //     this.state.isOptionsMenuOpen
  //   ) {
  //     this.setState({
  //       isChatLoading: false,
  //       showAvatar: false,
  //       isOptionsMenuOpen: false,
  //     });
  //     if (window.drift && window.drift.api && window.drift.api.widget) {
  //       window.drift.api.widget.hide();
  //     }
  //   }
  // };

  // _getInterationID = () => {
  //   const path = window.location.pathname;
  //   if (!path || (path && path === "/")) {
  //     return DRIFT_PLAYBOOKS.default
  //       ? DRIFT_PLAYBOOKS.default.interactionId
  //       : null;
  //   }

  //   let interaction = DRIFT_PLAYBOOKS.default;
  //   Object.keys(DRIFT_PLAYBOOKS).forEach(key => {
  //     if (path.indexOf(`/${key}`) !== -1) {
  //       const id = DRIFT_PLAYBOOKS[key];
  //       interaction = id || DRIFT_PLAYBOOKS.default;
  //     }
  //   });
  //   return interaction ? interaction.interactionId : null;
  // };

  // _initListners = (retry = true) => {
  //   if (window.drift) {
  //     window.drift.on("ready", api => {
  //       window.drift.on("startConversation", data => {
  //         if (this.state.isFirstLoad) {
  //           if (data && data.conversationId) {
  //             api.goToConversation(data.conversationId);
  //           } else {
  //             setTimeout(() => {
  //               api.openChat();
  //             }, 600);
  //           }
  //           this.state.isFirstLoad = false;
  //         }
  //       });
  //       const { interactionId } = this.state;
  //       api.widget.show();
  //       if (!this.state.conversationId) {
  //         if (interactionId) {
  //           api.startInteraction({
  //             interactionId,
  //             goToConversation: true,
  //             replaceActiveConversation: true,
  //           });
  //         } else {
  //           const intID = this._getInterationID();
  //           if (intID) {
  //             api.startInteraction({
  //               interactionId: intID,
  //               goToConversation: true,
  //               replaceActiveConversation: true,
  //             });
  //           } else {
  //             api.openChat();
  //           }
  //         }
  //       }

  //       window.drift.on("message", data => {
  //         if (!this.state.isChatOpen) {
  //           this.setState({
  //             isChatOpen: true,
  //             isChatLoading: false,
  //             isOptionsMenuOpen: false,
  //             showAvatar: false,
  //             conversationId: data.conversationId,
  //           });
  //         }
  //       });
  //     });
  //     window.drift.on("chatClose", api => {
  //       api.widget.hide();
  //       this._handleChatClose();
  //     });
  //   } else if (retry) {
  //     setTimeout(this._initListners, 3000);
  //   }
  // };

  // _handleChatClose = () => {
  //   if (this.state.showAvatar) {
  //     writeDataToLocalStorage("isDriftAvatarShown", true);
  //   }
  //   this.setState({
  //     isChatOpen: false,
  //     isChatLoading: false,
  //     showAvatar: false,
  //     isOptionsMenuOpen: false,
  //   });
  // };

  _hideAvatarButton = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    writeDataToLocalStorage("isDriftAvatarShown", true);
    this.setState({ showAvatar: false, isOptionsMenuOpen: false });
  };

  _getChatAvatarView = () => (
    <Fragment>
      <div className="drift-speech-bubble">
        <FontAwesomeIcon
          size="1x"
          icon={["far", "times-circle"]}
          className="drift-avatar-close-btn"
          onClick={this._hideAvatarButton}
        />
        🙋🏻‍♂️ Hey there! Feel free to ping us. We are here for you!
      </div>
      <img
        src={
          this.state.avatarImage ? this.state.avatarImage : CHAT_PERSON_IMAGE
        }
        alt="drift-chat-person"
        className="drift-chat-person"
      />
      <span className="drift-chat-dot" />
    </Fragment>
  );

  _getOptionsItemView = item => (
    <li key={`${item.id}`}>
      <div
        className="help-fab-options-item"
        role="button"
        data-test="test-atrib"
        onClick={() => {
          this._handleItemClick(item);
        }}
        tabIndex={0}
        onKeyPress={() => {}}>
        <div>
          {item.icon && (
            <FontAwesomeIcon
              size="sm"
              icon={["far", `${item.icon}`]}
              className="help-fab-option-icon"
            />
          )}
        </div>
        <div>
          <div className="help-fab-option-title">{item.title}</div>
          <div className="help-fab-option-subtext">{item.subtext}</div>
        </div>
        <div>
          {item.link && (
            <FontAwesomeIcon
              size="sm"
              icon={["fal", `external-link`]}
              className="help-fab-option-icon-link"
            />
          )}
        </div>
      </div>
    </li>
  );

  _toggleOptionsMenu = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState(
      state => ({
        isOptionsMenuOpen: !state.isOptionsMenuOpen,
        showAvatar: false,
      }),
      () => {
        if (!this.state.isOptionsMenuOpen) {
          if (window.FreshworksWidget) {
            window.FreshworksWidget("close");
          }
          this.setState({ isChatOpen: false });
        }
      },
    );
  };

  _getUserAvatarImg = () => {
    if (!process.env.REACT_APP_DRIFT_APPID) {
      return;
    }

    getDriftAvatarImage(process.env.REACT_APP_DRIFT_APPID).then(
      configPayload => {
        // if default user is not set then pick any one
        if (
          configPayload &&
          configPayload.configuration &&
          configPayload.configuration.team &&
          Array.isArray(configPayload.configuration.team) &&
          configPayload.configuration.team.length > 0
        ) {
          const currentUser = configPayload.configuration.team.filter(
            user => user.avatarUrl && user.id === 1915862,
          );
          if (
            currentUser.length > 0 &&
            currentUser[0].avatarUrl &&
            currentUser[0].status === "ENABLED"
          ) {
            this.setState({ avatarImage: currentUser[0].avatarUrl });
          }
        }
      },
    );
  };

  componentDidMount() {
    if (this.state.showAvatar) {
      this._getUserAvatarImg();
      setTimeout(() => {
        writeDataToLocalStorage("isDriftAvatarShown", true);
      }, 5000);
    }
    //  document.addEventListener("click", this._handleOustideClick, false);
  }

  // componentDidUpdate() {
  //   const interactionId = this._getInterationID();
  //   this.state.interactionId = interactionId;
  // }

  // componentWillUnmount() {
  //   document.removeEventListener("click", this._handleOustideClick, false);
  // }

  _onFreshWorksWidgetOpen = () => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    this.setState({ isChatLoading: false });
    window.FreshworksWidget("open");
    if (CURRENT_USER && CURRENT_USER.username) {
      window.FreshworksWidget("identify", "ticketForm", {
        name: `${CURRENT_USER.first_name} ${CURRENT_USER.last_name}`,
        email: CURRENT_USER.username,
      });
    }
  };

  render() {
    const {
      isChatOpen,
      options,
      isChatLoading,
      showAvatar,
      isOptionsMenuOpen,
    } = this.state;
    let className = "help-fab-container";
    if (this.props.hideOnMobile) {
      className += " hide-on-mobile";
    }
    return (
      <div className={className}>
        {isChatOpen && (
          <Fragment>
            {/**
                   <Drift
              appId={process.env.REACT_APP_DRIFT_APPID}
              isLoading={isChatLoading}
              initListners={this._initListners}
            />
           */}
            <FreshWorksWidget onChatLoad={this._onFreshWorksWidgetOpen} />
          </Fragment>
        )}
        {isChatLoading && <DriftLoader />}
        {!isChatLoading && (
          <Fragment>
            <div
              role="button"
              onClick={this._toggleOptionsMenu}
              tabIndex={0}
              onKeyPress={() => {}}
              data-test="drift-options-menu-toggle-btn"
              className="help-fab-icon-container">
              {!showAvatar && !isOptionsMenuOpen && (
                <svg
                  className="help-fab-icon help-fab-chat-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 25 25">
                  <path
                    fill="#ffffff"
                    d="M23.295 24.412a.987.987 0 0 1-1.123-.43L19.9 20.358H9.527c-1.392 0-2.523-1.153-2.523-2.57V16.3c0-.563.448-1.02 1-1.02.553 0 1 .457 1 1.02v1.485c0 .295.235.533.523.533h10.92c.036 0 .067.018.103.022a.96.96 0 0 1 .527.224.984.984 0 0 1 .14.15c.023.026.054.043.073.075l.725 1.154V9.7a.528.528 0 0 0-.523-.532h-1.48c-.55 0-1-.457-1-1.02 0-.56.45-1.018 1-1.018h1.48c1.392 0 2.524 1.152 2.524 2.57V23.433c0 .452-.293.85-.72.978zM14.49 13.226H4.116L1.844 16.85a.997.997 0 0 1-1.124.43 1.017 1.017 0 0 1-.72-.978V2.57C0 1.152 1.132 0 2.523 0H14.49c1.39 0 2.52 1.152 2.52 2.57v8.085c0 1.418-1.13 2.57-2.52 2.57zm.52-10.656a.528.528 0 0 0-.52-.532H2.522c-.288 0-.522.24-.522.532v10.242l.726-1.153c.02-.032.05-.05.07-.076a.897.897 0 0 1 .296-.256.92.92 0 0 1 .372-.118c.037-.004.068-.022.104-.022h10.92c.288 0 .522-.238.522-.533V2.57z"
                  />
                </svg>
              )}
              {!showAvatar && isOptionsMenuOpen && (
                <FontAwesomeIcon
                  size="2x"
                  icon={["fal", "times"]}
                  className="help-fab-icon help-fab-close-icon"
                />
              )}

              {showAvatar && this._getChatAvatarView()}
            </div>
            {isOptionsMenuOpen && (
              <ul className="help-fab-options">
                {options && options.map(item => this._getOptionsItemView(item))}
              </ul>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => {
  const isAvatarShown = readDataFromLocalStorage("isDriftAvatarShown");
  return { showAvatar: typeof isAvatarShown === "undefined" };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DriftWidget);
